import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { useData } from '@pure-ptr/react';

import {
    Portlet, PortletBody,
    PortletHeader
} from "../../../partials/content/Portlet";

import {
    Grid,
    Button
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { PagedTable } from '../../../common';
import { useLocation } from 'react-router-dom';
import { generateStats } from "../../../store/api/pricers";
import { errorToastify, infoToastify } from "../../../util/toast";

const DEFAULT_SORT = [{ id: 'id', direction: 'desc' }];

const useStyles = makeStyles(theme => ({
    generateBtn: {
        height: 'fit-content',
        marginTop: '25px',
        marginBottom: '8px',
        marginRight: '10px',
        minWidth: 'fit-content',
    },
}));

export default function EDIExecutionPage(props) {
    const classes = useStyles();
    const [refresh, setRefresh] = useState(Promise.resolve());
    const [submitGenerateStats, setSubmitGenerateStats] = useState(false);

    const { clientId, isSuperAdmin } = props;

    const {
        error: generateStatsError,
        isPending: generateStatsPending,
        reload: generateRates
    } = useData(async () => {
        if (!submitGenerateStats) return;
        setSubmitGenerateStats(false);
        await generateStats(clientId);
    }, [clientId]);

    useEffect(() => {
        if (!generateStatsError) return;
        errorToastify(generateStatsError?.payload?.error || "Failed to generate pricer stats.");
    }, [generateStatsError]);

    const handleSubmitGenerateStats = () => {
        setSubmitGenerateStats(true);
        infoToastify("Stats generation is in progress. You will be notified once it is complete.");
        generateRates();
    };

    const search = useLocation().search;
    const executionId = new URLSearchParams(search).get('executionId');

    const {
        fields,
        executionsData,
        actions: {
            executionsLanding,
            searchGetByName,
            setFilter,
            resetCriteriaWaiting,
            resetErrorMessages,
            resetPagedTable
        }
    } = props;

    function handleLoad(sort, filter, pagination) {
        executionsLanding(pagination, sort, filter);
    }

    useEffect(() => {
        if (executionId && executionId !== 'list') {
            const idFilter = {
                field: 'id',
                equator: 'equals',
                value: executionId,
            }
            setFilter([idFilter]);
        }
    }, [executionId]);

    useEffect(() => {
        handleRefresh();
    }, [setFilter]);

    function handleRefresh() {
        setRefresh(Promise.resolve());
    }

    useEffect(() => {
        const pageName = {
            name: 'edi-executions-landing'
        }
        resetCriteriaWaiting(pageName.name)


        return function cleanup() {
            // searchReset();
            resetPagedTable(pageName.name);
        }
    }, [searchGetByName]);



    return (<>
        <Helmet title="Analysis Executions" />
        <Portlet>
            <PortletHeader
                title="Pricer Statistics Logs"
                name="edi-executions-landing"
                handleRefresh={handleRefresh}
                showSearchFilters={true}
                showSearchFiltersDropdown={false}
                shouldNotSetDefault={executionId === null ? false : true}
                includeAdvanceFilters={true}
                toolbar={
                    isSuperAdmin ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmitGenerateStats}
                            disabled={generateStatsPending !== null}
                            className={`${classes.generateBtn} generate-pricer-stats-btn`}
                        >
                            {generateStatsPending !== null ? "Generating..." : "Generate Pricer Stats"}
                        </Button>
                    ) : undefined
                }
            />
            <PortletBody>
                <div>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <PagedTable
                                name="edi-executions-landing"
                                title="Pricer Statistics Logs"
                                fields={fields}
                                data={executionsData}
                                onLoad={handleLoad}
                                refresh={refresh}
                                defaultSort={DEFAULT_SORT}
                                criteriasSaveEnabled={true}
                                hasActions={false}
                                showSearchFilters={true}
                            />
                        </Grid>
                    </Grid>
                </div>
            </PortletBody>
        </Portlet>
    </>);
}